import React from 'react';
import './Footer.css';
import {Link} from 'react-router-dom'

function Footer() {
  return (
    <div className='footer-container'>
      <footer className="text-white pt-4">
        <div className="container">
          <div className="row">
            {/* About Us Section */}
            <div className="col-md-4">
              <h5>About Us</h5>
              <p>
                We offer unique and adventurous safari tours, providing a glimpse of wildlife and the natural beauty of Uganda.
              </p>
            </div>

            {/* Quick Links Section */}
            <div className="col-md-4">
              <h5>Quick Links</h5>
              <ul className="list-unstyled">
                <li><Link to="/" className="text-white text-decoration-none">Home</Link></li>
                <li><Link to="/1" className="text-white text-decoration-none">Tours</Link></li>
                <li><Link to="/about" className="text-white text-decoration-none">About Us</Link></li>
                <li><Link to="/contact" className="text-white text-decoration-none">Contact</Link></li>
              </ul>
            </div>

            {/* Social Media Section */}
            <div className="col-md-4">
              <h5>Follow Us</h5>
              <div className="d-flex text-white">
                <a href="https://www.facebook.com/people/Japland-Tours" target="_blank" rel="noopener noreferrer" className="text-white me-3">
                  <i className="fab fa-facebook fa-2x text-white"></i>
                </a>
                <a href="https://www.instagram.com/japlandtours/" target="_blank" rel="noopener noreferrer" className="text-white me-3">
                  <i className="fab fa-instagram fa-2x text-white"></i>
                </a>
                <a href="https://youtu.be/vvbgXmUoRU8?si=KRBm9jGGbtc9Jyul" target="_blank" rel="noopener noreferrer" className="text-white me-3">
                  <i className="fab fa-youtube fa-2x text-white"></i>
                </a>
                <a href="https://wa.me/+971551579904" target="_blank" rel="noopener noreferrer" className="text-white me-3">
                  <i className="fab fa-whatsapp fa-2x text-white"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="text-center py-3 mt-4">
          <p className="mb-0">&copy; 2024 Japland Tours And Safaris Uganda. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
